import script from "./BaseDropzoneImage.vue?vue&type=script&setup=true&lang=js"
export * from "./BaseDropzoneImage.vue?vue&type=script&setup=true&lang=js"

import "./BaseDropzoneImage.vue?vue&type=style&index=0&id=cbbc2f7a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cbbc2f7a"]])

export default __exports__